import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { OrganisationService } from 'src/app/Services/organisation.service';
import { SharedService } from 'src/app/Services/shared.service';
import { environment } from 'src/environments/environment';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss']
})
export class LoginViewComponent implements OnInit {
  public user: any = {};
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  showPassword = false;
  public licenseExpiredMessage: string = '';
  public brand = getBrand();

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private _sharedService: SharedService,
    private notifys: NotifyService,
    private organisationService: OrganisationService,
    private http: HttpClient // Inject HttpClient
  ) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    this._sharedService.loaderHide.emit(true);
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/project';
    if (localStorage.getItem('currentUser')) {
      const jwtToken = JSON.parse(localStorage.getItem("currentUser")).token;
      let parsedToken = this.parseJwt(jwtToken);
      if (!this.isTokenExpired(parsedToken.exp)) {
        this.authenticationService.isAuthTokenValid(jwtToken).subscribe(
          data => {
            if (data) {
              window.location.href = this.returnUrl;
            } else {
              localStorage.clear();
              this._sharedService.loaderHide.emit(false);
            }
          }, (error: any) => {
            // localStorage.clear();
            this._sharedService.loaderHide.emit(false);
          }
        );
      } else {
        localStorage.clear();
        this._sharedService.loaderHide.emit(false);
      }
    } else {
      this._sharedService.loaderHide.emit(false);
    }
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  isTokenExpired(exp: number): boolean {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in epoch format (seconds)
    return currentTime >= exp;
  }

  get f() { return this.loginForm.controls; }


  onSubmit() {
    this.submitted = true;
    this._sharedService.loaderHide.emit(true);

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    localStorage.setItem("username", this.f.username.value);
    this.authenticationService.login(this.f.username.value, this.f.password.value).subscribe(
      data => {
        this._sharedService.loaderHide.emit(false);
        // this.checkLicenseValidity(); // Call the license validity check
        if (typeof data === 'string' && data.includes('License has expired for user')) {
        localStorage.clear();
        this.loading = false;
      } else {
        // Normal successful login flow
        this.organisationService.getUserAssignedLicenses(this.f.username.value).subscribe(
          (licenseResponse: any) => {
            if (licenseResponse && licenseResponse.operationStatus === 'SUCCESS' && licenseResponse.data && licenseResponse.data.length > 0) {
              // Extract licenseId from the first license in the response
              const licenseId = licenseResponse.data[0]._id.$oid || licenseResponse.data[0]._id;
              if (licenseId) {
                localStorage.setItem("licenseId", licenseId);
              } else {
                // license model exists but id is missing; persist null placeholder
                localStorage.setItem("licenseId", "null");
              }
            } else {
              // No license model; allow login to proceed without it
              localStorage.setItem("licenseId", "null");
            }
            window.location.href = this.returnUrl;
          },
          (error) => {
            console.error('Error getting user licenses:', error);
            // Fall back to login without license if lookup fails
            localStorage.setItem("licenseId", "null");
            window.location.href = this.returnUrl;
          }
        );
      }
      },
      error => {
        if (error.includes('License has expired for user')){
          this.error= 'License has expired. Please renew your license.'
        } else {
          this.error = 'Incorrect email or password. Please try again';
        }
         this._sharedService.loaderHide.emit(false);
         this.loading = false;
      }
    );
  }

  checkLicenseValidity() {
    const licenseInfoUrl = environment.backendEndpoint + ":8080/licenseInfo";
    this.http.get<any>(licenseInfoUrl).subscribe(
      response => {
        const currentTime = Date.now();
        if (response.license_validity < currentTime) {
          // alert('License validity has expired. Please renew your license.');
          this.licenseExpiredMessage = 'License validity has expired. Please renew your license.';
          localStorage.clear();
        } else {
          window.location.href = this.returnUrl;
        }
      },
      error => {
        console.error('Failed to fetch license info', error);
        alert('Failed to validate license. Please try again later.');
        localStorage.clear();
        window.location.href = this.returnUrl;
      }
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}